export const styleguide = 'styleguide';
export const errorPage = 'errorPage';
export const loading = 'loading';
export const subpage = 'subpage';
export const frontpage = 'frontpage';
export const apartments = 'apartments';
export const apartment = 'apartment';
export const articles = 'articles';
export const article = 'article';
export const contactUs = 'contactUs';
export const application = 'application';
